(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('LocationInfoSearch', LocationInfoSearch);

    LocationInfoSearch.$inject = ['$resource', 'ENV'];

    function LocationInfoSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/location-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
